import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './context/AuthContext';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import PraticheAuto from './pages/PraticheAuto';
import CommissioniAllRent from './pages/CommissioniAllRent';

import Utenti from './pages/Utenti';
import Profilo from './pages/Profilo';
import DashboardCdG from './pages/DashboardCdG';
import Dipendenti from './pages/Dipendenti';
import CostiPersonale from './pages/CostiPersonale';
import CostiGenerali from './pages/CostiGenerali';
import ImpostazioniKPI from './pages/ImpostazioniKPI';
import MovimentiUSave from './pages/MovimentiUSave';
import CompravenditaV2 from './pages/CompravenditaV2';
import MovimentiCompravendita from './pages/MovimentiCompravendita';
import NoleggioV2 from './pages/NoleggioV2';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{ padding: '2rem', textAlign: 'center' }}>Caricamento...</div>;
  }

  return user ? children : <Navigate to="/login" />;
}

function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={
        <PrivateRoute>
          <Layout />
        </PrivateRoute>
      }>
        <Route index element={<Dashboard />} />
        <Route path="pratiche-auto" element={<PraticheAuto />} />
        <Route path="commissioni-allrent" element={<CommissioniAllRent />} />
        <Route path="movimenti-usave" element={<MovimentiUSave />} />

        <Route path="compravendita" element={<CompravenditaV2 />} />
        <Route path="movimenti-compravendita" element={<MovimentiCompravendita />} />
        <Route path="noleggio" element={<NoleggioV2 />} />
        <Route path="utenti" element={<Utenti />} />
        <Route path="profilo" element={<Profilo />} />
        <Route path="cdg" element={<DashboardCdG />} />
        <Route path="cdg/dipendenti" element={<Dipendenti />} />
        <Route path="cdg/costi-personale" element={<CostiPersonale />} />
        <Route path="cdg/costi-generali" element={<CostiGenerali />} />
        <Route path="cdg/kpi" element={<ImpostazioniKPI />} />
      </Route>
    </Routes>
  );
}

export default App;
